export enum eAppRoutes {
    Home = '/',
    Auth = 'auth',
    Groceries = 'groceries',
    Profile = 'profile',
    Groups = 'groups',
    Recipes = 'recipes',
    Analytics = 'analytics',
    Nutrition = 'nutrition',
}
